export default function script_burgerMenu() {
	document.addEventListener('DOMContentLoaded', () => {
		const globalNav = document.getElementById('globalNav')
		const burgerBtn = document.getElementById('burgerBtn')
		const burgerBack = document.getElementById('burgerBack')
		const container = document.getElementById('container')
		burgerBtn.addEventListener('click', () => {
			globalNav.classList.toggle('panelactive')
			burgerBtn.classList.toggle('active')
			burgerBack.classList.toggle('backactive')
			container.classList.toggle('fix')  //バーガーボタンが押されたら背景のスクロールを固定する
		})
	})
}
